// extracted by mini-css-extract-plugin
module.exports = {"burgerConstructor":"burger-constructor_burgerConstructor__1Ei5R","confirmButton":"burger-constructor_confirmButton__3accQ","total":"burger-constructor_total__2z4fk"};